import * as React from 'react'
import { Redirect } from 'react-router-dom'

import OAuth2Service from '../../services/OAuth2'
import AuthService from '../../services/Auth'


interface CallbackProps {}

export class Callback extends React.Component<CallbackProps, any> {
  oAuth2Service = new OAuth2Service()

  render() {
    return (
      <div>
        {new AuthService().login(this.oAuth2Service.getToken(window.location.href), this.oAuth2Service.getUserId(window.location.href))}
        <Redirect to={this.oAuth2Service.getActivatedRoute(window.location.href)} />
      </div>
    )
  }
}

